

(function($) {
    // Hamburger menu
    // $('.search-form button.reset').on('click', function(e) {
    //   $('body').removeClass('show-search');
    // });
    
    // $('.search-toggle').on('click', function (e) {
    //   $('body').addClass('show-search');
    // });
    
  $('.menu-toggle, .edn-star').on('click touchstart', function(e) {
    $('body').toggleClass('menu-open');
    $('html').toggleClass('no-scroll');
    $('.hamburger-button').toggleClass('is-active');
    e.preventDefault();
  });

  // Menu standaard uit beeld (Z-index 2)
  // Sectionheader is fixed en main scrolled eroverheen
  // Menu open, dan alles laten zakken todat menu in beeld is

  const ednNav = $('.edn-nav');
  const ednSiteHeader = $('.edn-site-header');
  const ednMain = $('.edn-main');
  const ednStar= $('.edn-star');

  const animation = {
    speed : '1s',
    gsapSpeed: 0.7,
    easing : 'ease-in-out'
  };

  var navOpen = false;
  var isAnimating = false;
  var siteHeaderYPos = 0;
  var scrollPosition = 0;

  function toggle() {
    if( isAnimating ) return;
    isAnimating = true;
    navOpen = !navOpen;
    if( navOpen )
      disableScroll();
    else 
      enableScroll();
    update(true);
  }

  function refresh() {
    isAnimating = false;
    update(false);
  }

  function disableScroll() {
    scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.width = '100%';
  }

  function enableScroll() {
    document.body.style.position = '';
    document.body.style.overflow = '';
    document.body.style.top = '';
    window.scrollTo(0, scrollPosition);
  }

  function update( doAnimation ) {
    let ednNavHeight = $('.edn-nav').outerHeight();
    let ednSiteHeaderHeight = $('.edn-site-header').outerHeight();

    let menuClosed = { y : (-1 * ednNavHeight) };
    let menuOpen = { y : 0 };

    if( !doAnimation ) {
      // Zonder animatie (reset animatie ook)
      if( !navOpen) {
        ednNav.stop().css({ 'transform' : 'translateY(' + menuClosed.y + 'px)' });
        // ednSiteHeader.stop().css({ 'top' : '0px' });
        ednMain.stop().css({ 'top' : ednSiteHeaderHeight + 'px' });
      } else {
        ednNav.stop().css({ 'transform' : 'translateY(' + menuOpen.y + 'px)' });
        // ednSiteHeader.stop().css({ 'top' : ednNavHeight + 'px' });
        // ednMain.stop().css({ 'top' : ednNavHeight + 'px' });
      }
      isAnimating = false;
    } else {
      // Met animatie
      if( !navOpen) {
        console.log('close');
        // menu
        $(menuOpen).animate( menuClosed, {
          duration: animation.speed,
          step : function( val ) {
            ednNav.css("transform", `translateY(${val}px)`);
          },
          done : function() {
            isAnimating = false
          }
        });
        // siteheader
        // $({y:ednNavHeight}).animate( {y:0}, {
        //   duration: animation.speed,
        //   step : function( val ) {
        //     ednSiteHeader.css("top", `${val}px`);
        //   }
        // });
        // gsap.to(ednSiteHeader, {
        //   y: siteHeaderYPos + 'vh',
        //   duration: animation.gsapSpeed
        // });
        // main
        $({y:ednNavHeight}).animate( {y:0}, {
          duration: animation.speed,
          step : function( val ) {
            ednMain.css("transform", `translateY(${val}px)`);
          }
        });
      } else {
        // menu
        console.log('open');
        $(menuClosed).animate( menuOpen, {
          duration: animation.speed,
          step : function( val ) {
            ednNav.css("transform", `translateY(${val}px)`);
          },
          done : function() {
            isAnimating = false
          }
        });
        // siteheader
        // $({y:0}).animate( {y:ednNavHeight}, {
        //   duration: animation.speed,
        //   step : function( val ) {
        //     ednSiteHeader.css("top", `${val}px`);
        //   }
        // });
        // siteHeaderYPos = gsap.getProperty('.edn-site-header', 'y');
        // gsap.to(ednSiteHeader, { 
        //   duration: animation.gsapSpeed, 
        //   y: "0" 
        // });
        // main
        $({y:0}).animate( {y:ednNavHeight}, {
          duration: animation.speed,
          step : function( val ) {
            ednMain.css("transform", `translateY(${val}px)`);
          }
        });
      } 
      isAnimating = false;
    }

  }

  $(window).on('resize', refresh);
  $(document).ready( refresh );

  gsap.to(ednSiteHeader, {
    y: "-25vh",
    ease: "none",
    scrollTrigger: {
      trigger: "body",
      start: "top top",
      end: () => `+=${window.innerHeight}px`,
      scrub: true,
      // markers: true
    }
  });

  // ScrollTrigger.create({
  //   trigger: "body",
  //   start: "-1px",
  //   // markers: true,
  //   end: () => `+=${ednSiteHeader.outerHeight()}px`,
  //   onToggle: function( self )  {
  //     if( self.isActive ) 
  //       ednNav.removeClass('show-only-top');
  //     else 
  //       ednNav.addClass('show-only-top');
  //   }
  // });

  
  

  
})(jQuery);